import { Stack, Typography } from '@mui/material'
import { LastEquipmentInteractionDto } from '@operations/app/api'
import { DescriptionContainer } from '@operations/features/equipmentOperator/components/JobCard/DescriptionContainer'
import { formatStringDate } from '@operations/utils/format-date'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, Tile, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  lastInteraction?: LastEquipmentInteractionDto
}
export const OperationalEquipmentLastInteraction = observer(({ lastInteraction }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <DescriptionContainer>
      <Stack gap={theme.customSpacing.xs}>
        <Typography variant='subtitle1'>{t('lastInteraction', 'Last interaction')}</Typography>

        {(lastInteraction && (
          <Stack gap={theme.customSpacing.xl} flexDirection='row' alignItems='center'>
            <Tile label={t('unit', 'Unit')} value={lastInteraction.unitNumber ?? EmptyIndicator} />
            <Tile
              label={t('carrier', 'Carrier')}
              value={lastInteraction.carrierName ?? EmptyIndicator}
            />
            <Tile label={t('visit', 'Visit')} value={formatStringDate(lastInteraction.ata)} />
            <Tile
              label={t('equipmentType', 'Equipment type')}
              value={lastInteraction.equipmentType ?? EmptyIndicator}
            />
            <Tile
              label={t('equipmentName', 'Equipment name')}
              value={lastInteraction.equipmentName ?? EmptyIndicator}
            />
            <Tile label={t('user', 'User')} value={lastInteraction.userName ?? EmptyIndicator} />
            <Tile
              label={t('dateAndTime', 'Date and time')}
              value={formatStringDate(lastInteraction.dateTime)}
            />
          </Stack>
        )) || (
          <Typography variant='body2'>
            {t('noJobExecutedByTheEquipment', 'No job executed by the equipment')}
          </Typography>
        )}
      </Stack>
    </DescriptionContainer>
  )
})
